module.exports = __webpack_public_path__ + "static/media/theater-masks.ea3813e6.png";